import { anchorClass } from './channel'

const AdvertiseContent = () => {
    return (
        <div className="flex h-full w-full items-center justify-center">
            <a href="https://ads.giphy.com" rel="noopener noreferrer" target="_blank" className={anchorClass}>
                Case Studies
            </a>
            <div className="h-8 w-0 border-l-2 border-white opacity-30" />
            <a href="https://ads.giphy.com" rel="noopener noreferrer" target="_blank" className={anchorClass}>
                Work with Us
            </a>
        </div>
    )
}

export default AdvertiseContent
